export default {
  setApplicationVersion(state, payload) {
    state.appVersion = payload;
  },
};
